<div class="modal-body">
    <div class="alert" [ngClass]="{'alert-default' : modalData.warningLevel === 'default', 'alert-danger': modalData.warningLevel === 'danger' }">{{modalData.modalMessage}}</div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="cancelClicked()">
        {{closeButtonText}}
    </button>
</div>
